import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "min-h-screen flex flex-column surface-ground" }
const _hoisted_2 = {
  class: "surface-overlay px-6 flex justify-content-between relative lg:static",
  style: {"min-height":"80px"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: "/images/logo.png",
  alt: "Image",
  height: "80",
  class: "mr-0 lg:mr-2 align-self-center"
}, null, -1 /* HOISTED */)
const _hoisted_4 = { class: "cursor-pointer block lg:hidden text-700 align-self-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-bars text-4xl" }, null, -1 /* HOISTED */)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "flex-grow-1 justify-content-between hidden lg:flex absolute lg:static w-full surface-overlay left-0 top-100 z-1 shadow-2 lg:shadow-none" }
const _hoisted_8 = { class: "list-none p-0 m-0 flex select-none flex-column lg:flex-row" }
const _hoisted_9 = { class: "active" }
const _hoisted_10 = {
  style: {"border-color":"var(--primary-color) !important"},
  class: "active flex h-full px-6 p-3 lg:px-3 lg:py-2 align-items-center text-600 hover:text-900 border-left-2 lg:border-bottom-2 lg:border-left-none border-transparent hover:border-primary font-medium cursor-pointer transition-colors transition-duration-150 p-ripple"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-home mr-2" }, null, -1 /* HOISTED */)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, "Cây thuốc", -1 /* HOISTED */)
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = { class: "list-none p-0 m-0 flex select-none flex-column lg:flex-row border-top-1 surface-border lg:border-top-none" }
const _hoisted_15 = { class: "border-top-1 surface-border lg:border-top-none" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-sign-out",
  style: {"font-size":"2rem"}
}, null, -1 /* HOISTED */)
const _hoisted_17 = { class: "p-5 flex flex-column flex-auto" }
const _hoisted_18 = { class: "border-2 border-dashed surface-border border-round surface-section flex-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!
  const _directive_ripple = _resolveDirective("ripple")!
  const _directive_styleclass = _resolveDirective("styleclass")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_4, _hoisted_6)), [
        [_directive_ripple],
        [_directive_styleclass, { selector: '@next', enterClass: 'hidden', leaveToClass: 'hidden', hideOnOutsideClick: true }]
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("ul", _hoisted_8, [
          _createElementVNode("li", _hoisted_9, [
            _createVNode(_component_router_link, { to: {name: 'plants'} }, {
              default: _withCtx(() => [
                _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_10, _hoisted_13)), [
                  [_directive_ripple]
                ])
              ]),
              _: 1 /* STABLE */
            })
          ])
        ]),
        _createElementVNode("ul", _hoisted_14, [
          _createElementVNode("li", _hoisted_15, [
            _withDirectives((_openBlock(), _createBlock(_component_router_link, {
              to: {name: 'logout'},
              class: "flex h-full px-6 p-3 lg:px-3 lg:py-2 align-items-center border-left-2 lg:border-bottom-2 lg:border-left-none border-transparent hover:border-primary font-medium cursor-pointer transition-colors transition-duration-150 p-ripple"
            }, {
              default: _withCtx(() => [
                _hoisted_16
              ]),
              _: 1 /* STABLE */
            })), [
              [_directive_ripple]
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _createVNode(_component_router_view)
      ])
    ])
  ]))
}